import { render } from "./KnowledgeCardExpand.vue?vue&type=template&id=3a8e0864&scoped=true"
import script from "./KnowledgeCardExpand.vue?vue&type=script&lang=js"
export * from "./KnowledgeCardExpand.vue?vue&type=script&lang=js"

import "./KnowledgeCardExpand.vue?vue&type=style&index=0&id=3a8e0864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8e0864"]])

export default __exports__